module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('a', {
    attrs: {
      "id": "ch01"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER")]), _vm._v(" 1"), _c('br'), _c('strong', [_vm._v("Mexican Americans in 1940: Perceptions and Conditions")])]), _vm._v(" "), _c('p', {
    staticClass: "chapauthor"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("RICHARD STEELE")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Few Americans in 1940 knew their compatriots of Mexican origin firsthand. What most did know was a creation of the popular media that portrayed them, no matter which side of the border they lived on, either as peons with eyes averted and faces buried in oversized sombreros, or as treacherous, grinning, bandoleer-draped "), _c('em', [_vm._v("bandidos")]), _vm._v(". This mélange was leavened with the occasional appearance of a lighter-skinned but nonetheless indolent and irresponsible "), _c('em', [_vm._v("caballero")]), _vm._v(" vaguely associated with Mexico but more likely identified as “Spanish.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01fn1"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#ch01fn1a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the Southwest, where millions of Mexicans (as all people of Mexican extraction were known) lived, familiarity produced a slightly different image, but little enlightenment. To most white Americans (or “Anglos,” as they were referred to by the Mexican community), the term “Mexican” commonly conjured up images of the bent figures in a distant cotton field or the swarthy common laborers encountered in the region’s towns and cities. In either case, they were assumed by white Americans to be members of a ragged race of inferiors provided by providence to do the region’s most unpleasant work.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The pervading ignorance and hostility were reflected in a poll conducted in 1942, which asked a cross section of white Americans to rate the qualities of a list of “people[s] or races of the world … in comparison with the people of the United States.” The question was unexceptional in this era of ethnic stereotypes, an era before the concept of race had been questioned and before Americans were discouraged from making invidious comparisons between peoples. Those who responded predictably categorized the English, Dutch, and Scandinavians as being “as good as we … in all important respects”; ranked the Irish, French, and Germans as somewhat inferior; and placed the Greeks, “South Americans,” “Jewish "), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _vm._v("refugees,” Poles, Russians, Chinese, Spaniards, Italians, and Japanese, in that order, as more clearly alien and inferior to Americans. At the very bottom of the list, below the Japanese, with whom the United States was at war, were Mexicans, who were identified as being “as good as Americans” by only 12 percent of those surveyed, and as “definitely inferior” by a startling 59 percent."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01fn2"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#ch01fn2a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Official and informed opinion in the early 1940s was less judgmental but hardly more positive. Those who took an interest in America’s Mexicans saw them as suffering social and economic disabilities so intense and demoralizing that their resultant disaffection threatened national security. Reports commissioned by two federal agencies in 1942 described the Mexican immigrant and his progeny as constituting “probably the most submerged and destitute group in the United States”; employed in the “lowest paid and least desirable jobs”; plagued by illiteracy, juvenile delinquency, criminality, and disease; despised by the people among whom they lived; and presenting “perhaps the most striking need for economic rehabilitation and cultural assimilation in the entire United States.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01fn3"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#ch01fn3a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("These conclusions were certainly not valid for every Mexican American (the term used herein for convenience to designate all persons of Mexican descent in the United States regardless of nativity or citizenship). Nor can they even hint at the full range of personal stories subsumed under the generalizations. Yet both the stereotyped views of the general public and the more thoughtful, though culturally biased, assessments of the government investigators suggested that Mexican Americans confronted a problem compounded by their poverty and by the ignorance, hostility, and discriminatory habits of those around them. This chapter, then, explores the Mexican American condition and its social, political, and ideological contexts on the eve of World War II."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01fn4"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#ch01fn4a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Observers have estimated that approximately 3.5 million persons of Mexican descent lived in the United States in 1940."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01fn5"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#ch01fn5a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" The vast majority had come since the turn of the century, the last of a number of immigrant groups that had arrived in the United States in the four decades after 1880. Like other immigrant groups, most had embarked on the challenging journey to the United States for material reasons—to earn enough to return to their native land and start anew, or to make a better life for themselves in the new country. Unlike the others, they found themselves strangers in the very lands that were part of their patrimony. Texas, California, and the American Southwest, where most settled, had been part of Mexican territory until 1848, and although the region was, with the "), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _vm._v("exception of New Mexico, now dominated by Americans of European descent, or “Anglos,” it still bore traces of its past in the Spanish names of its towns, cities, and topographical features.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('strong', [_vm._v("The Mexican American Social-Economic Caste in 1940")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Only a handful of the descendants of the original pre-1848 settlers remained in Texas and California in 1940. Many had integrated into Anglo society, and they maintained a distant relationship with the far more numerous and impoverished immigrants. In New Mexico, there were more than 250,000 persons descended from the Mexican colonists who had settled in the northern borderlands of old Mexico from the sixteenth through the eighteenth centuries. They still lived in relative isolation, with their inherited culture largely intact. Preferring to be called Hispanos, Nuevo Mexicanos, New Mexicans, or Spanish-speaking Americans, they had maintained the Spanish language and colonial customs by minimizing their contact with the English-speaking people who settled among and around them in the nineteenth century. They, too, had little sense of identity with the Mexican immigrants whose language they shared."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01fn6"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#ch01fn6a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Most of the persons of Mexican descent in the United States in 1940 were not the offspring of early settlers, but rather immigrants and the immediate progeny of immigrants who had been driven from their homeland by poverty and revolution and drawn north over the past half century by the opportunity to work. The attraction was jobs provided by Anglo miners, farmers, and entrepreneurs who, having displaced the native population and pushed aside the early Mexican settlers, were feverishly exploiting the resource-rich land in the West. The major obstacle to the seemingly limitless bounty the region offered was a chronic shortage of labor, which they sought to remedy by recruiting workers from around the world. Foreign labor was preferred because the more “foreign” and more desperate they were, the harder working and less demanding those who came were likely to be, and the less likely to get a fair hearing for any grievances. Racism, the belief in a biologically determined hierarchy of peoples, helped serve the economic interests of employers, who could comfortably treat Mexicans—as they had Asian Americans—as an alien, transitory workforce, not worthy of a decent living or commanding the rights customarily enjoyed by “white” Americans. Employers promoted and used racial prejudices to ensure that Mexicans and others played their designated role in the economic scheme."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01fn7"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#ch01fn7a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0010-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Figure 1.1")]), _vm._v(". Cañoncito school before World War II, San Miguel County, New Mexico—an example of the kind of neglect and poverty that was common for rural Mexican Americans. George I. Sánchez Papers, University of Texas, Austin. Courtesy of University of Texas at Austin Libraries.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For a time, the Mexicans provided an ideal labor source as they moved into and out of the United States as the economy dictated."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01fn8"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#ch01fn8a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" When there was work, they came in numbers that outstripped the need. When the economy slowed and they were no longer needed or welcome to stay, they were likely to return to Mexico. But over time the arrangement gradually faltered as the immigrants, their dreams of returning to Mexico fading, chose to remain in settlements ("), _c('em', [_vm._v("colonias")]), _vm._v(") north of the border."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01fn9"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#ch01fn9a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" Having raised children and nurtured a uniquely Mexican American culture in the North, they were reluctant to move on at the first sign that American prosperity was ebbing."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01fn10"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#ch01fn10a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With the onset of the Great Depression in the 1930s, Mexican immigrants saw opportunities wither and hostility increase, but these were now not enough by themselves to force many Mexican Americans to leave. State and federal authorities, abetted by Mexican officials, undertook to repatriate the now “surplus” Mexican families whose labor was readily replaceable by the many destitute Anglo-Americans who roamed the countryside. Many expendable Mexicans, and their American-born dependents, were hustled out of the country to relieve bankrupt state relief resources in an often cruel campaign of expulsion. Although over a million immigrants of all nationalities left the United States in the 1930s, only the Mexicans were the objects of a systematic coercive expulsion."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01fn11"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#ch01fn11a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _vm._v("The repatriation effort was tacit recognition that the one-time migrant Mexican population had put down roots in the United States. Indeed, by 1940, large numbers had settled in Texas, mostly in small towns along the border and as far north as San Antonio, and in Southern California, chiefly in Los Angeles County. From both areas, a portion migrated throughout the Southwest and beyond, following the crops and returning in slack seasons. Perhaps half the Mexican American population toiled in agriculture, most as migratory workers cultivating and picking various crops."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01fn12"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#ch01fn12a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" A few established themselves as shopkeepers and professionals serving the Mexican American communities. Most of the rest worked as day laborers or in the low-paying jobs maintaining the railroads and working in the mines of the Southwest. At a time when more than a third of American workers were unionized, few Mexican Americans were. As they were competing with an endless supply of desperate workers from Mexico and elsewhere, their incomes were kept barely above the subsistence level and well below that paid to Anglo workers for comparable work.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Poverty was generally the lot of unskilled, especially migratory, labor in the United States; one need only recall the plight of the so-called Okies, poor white migrants (many from Oklahoma) who came to California in the late 1930s in search of work. Their plight was dramatized in John Steinbeck’s novel "), _c('em', [_vm._v("The Grapes of Wrath")]), _vm._v(". But economic problems for Mexican Americans were compounded by the disposition of Anglos to see them as part of a permanent underclass and to discriminate against them accordingly. Color prejudices were common throughout the United States, but Mexicans settled in areas where racial prejudice was deeply rooted and particularly strong. Darker on average than Anglos and stigmatized by name and language, the Mexicans were natural targets of the “race”-based discrimination that victimized American Indians, African Americans, and Asians. The fact that they were mostly unskilled, illiterate, and forced into subsistence living reinforced the assumptions concerning their supposed innate inferiority."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01fn13"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#ch01fn13a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" It was easy to stereotype them as unclean, unmotivated, slow, dishonest, able to live on less, and not fit to associate with “whites.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In Texas, a state that had been part of the slave-holding Confederacy during the American Civil War, Mexicans encountered a racial caste system that operated on the principle that denying some people (principally African Americans) rights legitimately enjoyed by whites simply enforced the natural order of things. In California, the political system had long been dedicated to obtaining and controlling an exploitable workforce "), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _vm._v("through race-based legal distinctions and selective law enforcement."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01fn14"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#ch01fn14a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" Historically, in both places, where these faltered, vigilantism could be counted on to enforce the caste system. By the time Mexicans arrived in the state in large numbers, employers were accustomed to carefully discriminating between their workers on “racial” grounds, and most workers had internalized the prevailing mores. Such attitudes undercut working-class solidarity and encouraged a sense among Anglos (of all ethnicities) that better wages and working conditions for them depended on the subordination of Mexican Americans.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The vagaries of racism produced anomalies such as these described by Charles S. Johnson in a survey of industrial employment in Los Angeles in 1926:")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("In certain plants where Mexicans were regarded as white, Negroes were not allowed to mix with them; where Mexicans were classified as colored, Negroes not only worked with them but were given positions over them. In certain plants Mexicans and whites worked together; in some others white workers accepted Negroes and objected to Mexicans; still in others white workers accepted Mexicans and objected to Japanese. White women worked with Mexican and Italian women but refused to work with Negroes. Mexicans and Negroes worked under a white foreman; Italians and Mexicans under a Negro foreman."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01fn15"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#ch01fn15a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Living conditions for most Mexican Americans were substandard, even by the low expectations of the time and place. Those who resided year-round in the cities or retreated to them in the off-season typically lived in densely populated run-down barrios where they were denied services (garbage collection, sewers, access to potable water) available to other urban residents. Rates of tuberculosis and infant mortality, indices of destitution, were high."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01fn16"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#ch01fn16a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Segregated and inferior school systems in both Texas and California reflected the Mexican Americans’ second-class status. In Texas, although no law established them, “Mexican schools” were the rule, particularly in the lower grades. This humiliating social policy failed to deliver the instruction it was presumably intended to provide, and despite a state law mandating compulsory education, Mexican American children on average received fewer months of instruction during the school year than their Anglo counterparts and fewer years of schooling overall. Indeed, according to an official survey done during the war, 42 percent of Mexican American children of school age received no education at all. The "), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _vm._v("instruction they did receive was inferior, helping perpetuate the cycle of poverty for the children trapped in the system."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01fn17"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#ch01fn17a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0013-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Figure 1.2")]), _vm._v(". A sign like those that appeared in many restaurants and public facilities in the Southwest during the 1930s and 1940s. Segregation was enforced by local ordinances, in real estate covenants, and in the practices of local businessmen. Dr. Héctor P. García Papers. Courtesy of Special Collections and Archives, Mary and Jeff Bell Library, Texas A&M University, Corpus Christi, Texas.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In California, the situation was very much the same. The state had a history of separating students of different cultures. Unlike in Texas, African Americans could attend schools with whites, but school districts might exclude the children of Asian and American Indian background. Although the law did not mention children of Mexican descent, in town after town in Southern California, school districts provided “Mexican schools.” The separation was not uniformly or rigidly imposed, and the children of middle-class Mexican American parents were often admitted to Anglo schools if their parents insisted. Nevertheless, on the eve of World War II, most Mexican American children in California attended classes apart from other children."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01fn18"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#ch01fn18a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The social stigma attached to segregation was sometimes noted and its pernicious effect in perpetuating an ill-educated underclass recorded. But despite one or two challenges to its application,"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01fn19"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#ch01fn19a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" the practice was "), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _vm._v("generally accepted."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01fn20"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#ch01fn20a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" Segregation was seen as a solution to the problem of educating Mexican Americans, not as a problem to be overcome. Mexican children, it was argued (perhaps with some justification), needed a special protective environment where they could be instructed in the English they were not exposed to at home. But little was done to give them the special instruction they needed. The “Mexican schools” were underfunded, often served as a dumping ground for less-competent teachers, and were usually inferior to the Anglo schools. At the base of these conditions were the convictions of school officials and the Anglo community that second rate was good enough for Mexicans."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01fn21"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#ch01fn21a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was an attitude that readily applied to other areas of Mexican American life. Restrictive covenants prohibiting the sale of homes to members of a variety of ethnic and racial groups were commonly found in property deeds throughout the country. In California and the Southwest, these legal agreements invariably named people of Mexican descent as among those ineligible to buy. Although many Mexican Americans preferred life in the friendly, if poor, precincts of the barrio, the covenants prevented those who chose to move out and up from doing so even if they were financially able. They thus tended to ghettoize Mexican Americans by denying them a principal vehicle of social mobility.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Persons of Mexican heritage were deprived of other civil rights as well. Those born in the United States or naturalized here were citizens and had a constitutional right to participate in electoral politics. But in Texas most were excluded from the Democratic Party primaries, whose outcome usually determined who was elected, and the vast majority were discouraged from voting in the general election by a poll tax that kept poorer citizens from the ballot box. There was no equality before the law for Mexican Americans. Officers of the law and representatives of government acted in ways that impressed upon Mexican Americans the not-too-subtle notion that this was not their country. In fifty counties where they constituted a significant portion of the population, one investigator reported that “persons of Mexican descent have never been known to be called for jury duty.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01fn22"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#ch01fn22a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" This meant that Mexican Americans involved in legal proceedings did not enjoy the presumed benefit of a jury that included their ethnic peers. Their second-class status was driven home in encounters with police, border officers, and other officials who adopted attitudes that ranged from disrespectful to humiliating. Police brutality was often visited upon Mexican Americans accused of crimes."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01fn23"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#ch01fn23a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The most obvious reminders of what was essentially a caste system—the demarcation of social status by race—were announcements posted "), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _vm._v("on restaurants and other places generally open to the public indicating that persons of Mexican descent would not be served. Movie theaters often segregated their Mexican American customers, confining them, with African Americans, to the balcony. The use of public toilets was also frequently denied to people identified as “Mexican,” and they were barred from or assigned special times for their use of public parks, swimming pools, and other recreational facilities."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01fn24"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#ch01fn24a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])]), _vm._v(" Such practices were not dictated by law, nor were they universal. Sometimes a person of Mexican descent learned of an establishment’s policy only after an employee (sometimes on their own authority) ignored him, ordered him around back, or denied him service entirely."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01fn25"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#ch01fn25a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The impact of such practices was obvious. Mexican Americans were deprived of services to which they were entitled and were daily reminded of their inferior status. In 1934, Emory Bogardus, a University of Southern California sociologist, wrote that such practices made Americans of Mexican lineage disheartened, resentful, and despairing of ever making a decent life for themselves or their children north of the border. Six years later, conditions and prospects for Mexican Americans remained much the same. Mexican Americans remained largely rural, disproportionately illiterate, mostly very poor, physically isolated from their Anglo neighbors, and deprived of the full potential of life in the United States.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Other racial and ethnic minorities have faced similar predicaments. In most instances, they organized and joined self-help and advocacy groups, demanded changes in public attitudes, and pressured politicians for changes in government policies. The efforts of African Americans and the National Association for the Advancement of Colored People are exemplary in this regard, and their successes in California (for example) are notable."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01fn26"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#ch01fn26a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])]), _vm._v(" But in 1940, such organizations and initiatives among Mexican Americans had not yet been successful in creating a sustainable national focus on civil rights.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A prerequisite was lacking in the greater Mexican American population. No such group consciousness, on a national level, was manifest in 1940. There were many Mexican communities in the United States, united by a common language and memories of a homeland with its recent revolutionary history. Although a growing number of Mexican Americans had begun to think of themselves in national terms, most as yet did not identify beyond their family, friends, barrio, "), _c('em', [_vm._v("colonia")]), _vm._v(", and parish.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Creating group consciousness and providing it with direction is often the function of a minority group’s elite, and one might have expected the descendents of early Spanish-speaking settlers, some of whom were "), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _vm._v("well placed socially and economically, to play this role. But many of these older families had little in common with Mexican immigrant populations and, in any case, sometimes sought to distance themselves from these impoverished newcomers."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01fn27"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#ch01fn27a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])]), _vm._v(" Nor did the clergy fill the vacuum. Most Mexican Americans were nominally Roman Catholic, and the Church had been a force in America for helping other immigrant groups achieve cohesiveness, status, and power. But the clergy that served the Mexican Americans, anticipating that their temporal salvation would be found in a return to the mother country, not in the United States, tended to align themselves with Mexican consular officials in promoting Mexican culture in the United States. It was a stratagem and an attitude that while attuned to current realities, neither fostered development of an indigenous leadership nor encouraged full participation in American life."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01fn28"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#ch01fn28a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It is true that there was no shortage of social clubs and "), _c('em', [_vm._v("mutualistas")]), _vm._v(" (mutual aid societies) serving the Mexican American communities located in the Southwestern states, and those who read Spanish had access to approximately forty newspapers (almost all weeklies) in their native language."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01fn29"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#ch01fn29a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])]), _vm._v(" But neither the aid societies nor the newspapers were apt to address larger issues of life in the United States,"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01fn30"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#ch01fn30a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])]), _vm._v(" and, in any event, they represented and reached relatively few. The San Antonio–based League of United Latin American Citizens ("), _c('span', {
    staticClass: "small"
  }, [_vm._v("LULAC")]), _vm._v(") and a few others had the potential to serve as a national advocacy group, but in 1940 no organization had yet been able to register the specific grievances or press the claims of a national Mexican American constituency on an ignorant and indifferent political establishment.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("One reason for this lack of representation was that the voting potential of the Mexican American rank and file had yet to be realized. Throughout the 1920s and 1930s Mexicans resident in the United States were among the least likely immigrants to take the steps necessary to secure American citizenship and hence the right to vote. Even on the eve of the Second World War, as other aliens flocked to immigration offices to take out their first papers or complete their naturalization, Mexicans, many of them long resident in the United States with apparently no intention of returning to Mexico, held back."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01fn31"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#ch01fn31a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])]), _vm._v(" Officials explained their reluctance to move to the threshold of political power on the Mexicans’ attachment to their homeland and a reluctance to forswear allegiance to Mexico."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01fn32"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#ch01fn32a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])]), _vm._v(" Poverty and a lack of education also played a role in keeping people from citizenship and the polls, as did the relative isolation and transience of many farmworkers. Many were also, with good reason, suspicious of American authorities, disillusioned with life in the United States, and "), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _vm._v("convinced that citizenship conveyed no protection against discrimination. Perhaps, as David Gutiérrez has suggested, many Mexican Americans were trapped in the transnational Hispanic culture of the "), _c('em', [_vm._v("colonias")]), _vm._v(" and found political involvement tangential, if not irrelevant, to their lives."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01fn33"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#ch01fn33a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])]), _vm._v(" Whatever the reasons, both contemporaries and recent scholars have noted that Mexican Americans lacked the singleness of purpose or the effective voice, on the national level, that was being mustered by other American minorities."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01fn34"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#ch01fn34a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])])]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('strong', [_vm._v("The Mexican Americans as an Ethnic Group")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("It was easy for the American public to overlook Mexican Americans, and the group remained relatively unknown to government officials and those who championed the rights of minorities in the 1930s."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01fn35"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#ch01fn35a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])]), _vm._v(" A handful of academic studies shaped informed perceptions, but these did not deal with Mexican American civil rights per se. The older works by Paul S. Taylor, of the University of California, and Emory S. Bogardus, at the University of Southern California, focused on the group dynamics and social pathology of the Mexican American."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01fn36"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#ch01fn36a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In 1940, George I. Sánchez, one of a handful of Mexican American academics, added to the slim body of works on the Mexican American an influential book on the plight of "), _c('em', [_vm._v("his")]), _vm._v(" people: the Spanish-speaking community of New Mexico. Significantly, Sánchez’s study focused on the New Mexicans’ cultural isolation and their propensity to live in the past, rather than on the racial prejudices they suffered at the hands of their Anglo neighbors."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01fn37"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#ch01fn37a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])]), _vm._v(" Like the experiences and outlook of the New Mexicans themselves, the work was only distantly related to the lives of Mexican Americans in California and Texas, and like most discussions of Mexican Americans, it barely mentioned civil rights. Partly as a result of these kinds of studies, Mexican Americans were seen as an ethnographic/anthropological curiosity, or as a dysfunctional subculture. Thus, when public officials spoke of the “Spanish-speaking” people of the Southwest, their minds turned to the colorful natives of New Mexico. And when they spoke of the “Mexican problem,” they referred not to the difficulties confronting the Mexican Americans in the arena of civil rights, but to the threat that Mexican American poverty posed to public health and the welfare of the larger society. Even Carey McWilliams’ popular "), _c('em', [_vm._v("Factories in the Field")]), _vm._v(" (1939), which dealt in part with Mexican American migrant workers, described their problems (like those of other "), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _vm._v("agricultural laborers) almost exclusively as the product of economic exploitation. And it is perhaps not surprising that in an era before the concept of civil rights was fully articulated, commentators failed to see the problems of Mexican Americans in these terms.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Although most Mexican Americans in 1940 had not reached the point where they thought of themselves as an American minority, their attitudes were changing. With the steep decline of immigration in the 1930s and the repatriation of hundreds of thousands of Mexican-born residents, the group came to be made up more and more of those born in the United States—people who harbored no illusions of returning to Mexico. Recognizing that life in the United States was what they would have to make of it, a growing minority were more interested than their parents had been in challenging the status quo through politics. By 1940, a small number had gone, or were going, to college, and a middle class of merchants, lawyers, and other professionals was emerging. Historian Mario T. García argues that by the onset of the Great Depression, a “Mexican American generation” was adopting American values and expectations. More conscious of their rights as Americans, they were more sensitive to the gap between the promises and realities of life in America."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01fn38"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#ch01fn38a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])]), _vm._v(" On the eve of World War II, García argues, a U.S.-committed, genuinely Mexican American leadership, inspired by the political and social reform activism of the New Deal, had begun to form. Nevertheless, that leadership, according to this view, would not mature until after the war. For the time being, Mexican American political power was not even commensurate with the group’s locally concentrated numbers."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01fn39"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#ch01fn39a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("National reform initiatives would not come from San Antonio or Los Angeles, where the largest concentrations of Mexican Americans lived, but from Washington, D.C. Not long after the Japanese attack on Pearl Harbor thrust the United States into war, federal officials suddenly developed a strong interest in the Mexican American population. This concern was not a response to group-generated pressures, or a reflection of official conscience. Learning more about Mexican Americans, and perhaps even addressing their problems, had become a matter of national security. Several federal agencies undertook studies based on what little had been written about the group and on observations and interviews gleaned from brief tours of Mexican American communities. The effort signaled a new national interest in the group and suggested that things were about to change.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1c385f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch01.vue
// module id = 81
// module chunks = 0